// extracted by mini-css-extract-plugin
module.exports = {"logo-placeholder":"logo_logo-placeholder__T44bb"};